export default "__VITE_PUBLIC_ASSET__7baf06ee__"